export default __webpack_public_path__ + "static/media/word_of_day_notification.1c2097d9.png";